import { render, staticRenderFns } from "./EditAddToWorkflow.vue?vue&type=template&id=4d1dde32&scoped=true&"
import script from "./EditAddToWorkflow.vue?vue&type=script&lang=js&"
export * from "./EditAddToWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./EditAddToWorkflow.vue?vue&type=style&index=0&id=4d1dde32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1dde32",
  null
  
)

export default component.exports